import { Routes } from '@angular/router';
import { DocumentEditorComponent } from './document-editor.component';

export const routes: Routes = [
  {
    path: '',
    component: DocumentEditorComponent
  }
];
